import { IAdSenseUnit } from '../../../types';

export interface IAdSenseProps {
  unit: IAdSenseUnit;
}

// Empty span is a hack to prevent it being collapsed by dfp if they share
// the same id
function AdSenseUnit({ unit }: IAdSenseProps) {
  return (
    <div id={unit.container}>
      <span />
    </div>
  );
}

export { AdSenseUnit };
